import { BENEFICIOS_SET } from "../../ActionTypes";

export const setFlgBeneficios = (estado) => (dispatch) => {
  dispatch({
    type: BENEFICIOS_SET,
    payload: estado
  });
};
